import _ from 'lodash';

/**
 * For now, this is just handling the summation of multiple metrics into a single metric. Any other generic
 * data processing can be added here as needed. data is modified in place.
 *
 * @param {Object} chartDef
 * @param {[Object]} data
 * @returns {{processedData: Object[], changed: boolean}}
 */
export function processData(chartDef, data) {
    let changed = false;
    const firstKey = chartDef?.chartTrends?.length ? chartDef.chartTrends[0].key : null;
    if (firstKey && data?.trends?.[firstKey]?.data?.length) {
        changed = chartDef.chartTrends.filter((def) => def?.aggregationKeys?.length).length > 0;
        if (changed) {
            chartDef.chartTrends
                .filter((def) => def?.aggregationKeys?.length)
                .forEach((def) => aggregateMetrics(def.key, def.aggregationKeys, data));
        }
    }
    return {
        changed,
        processedData: data,
    };
}

/**
 * The trend data looks like data.trends.<key>.data[x], where x is an index into the
 * time series, data[x].date is the UTC epoch time, and data[x].value is the y value.
 *
 * Sum the values for each aggregation key into the specified key at each data point in
 * the trend.
 *
 * @param {String} sumKey aggregation key
 * @param {[String]} keys keys for values to aggregate
 * @param {Object} data data to process
 */
function aggregateMetrics(sumKey, keys, data) {
    const firstKey = keys[0];
    const { trends } = data;
    trends[sumKey] = _.cloneDeep(trends[firstKey]);
    trends[firstKey].data.forEach((point, i) => {
        trends[sumKey].data[i].value = keys
            .map((key) => trends[key]?.data[i]?.value)
            .filter((value) => !_.isNil(value))
            .reduce((a, b) => a + (b || 0), 0);
    });
}
